import { Component, OnInit } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";

@Component({
  selector: 'app-add-product-range-modal',
  templateUrl: './add-product-range-modal.component.html',
  styleUrls: ['./add-product-range-modal.component.scss']
})
export class AddProductRangeModalComponent implements OnInit {

  public product_range: any = {};

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,

  ) {}

  ngOnInit() {}

  public closeModal() {
    this.bsModalRef.hide();
    /*   this.modalService.setDismissReason('modalClosed');*/
    this.modalService.setDismissReason("modalClosed");
  }

  public closeModalAfterSave() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("modalSaved");
  }

  public createProductRange(event) {
    this.closeModalAfterSave()
  }

}



// WEBPACK FOOTER //
// /app/src/app/supplier-evaluation-form/add-product-range-modal/add-product-range-modal.component.ts